// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>

import { path } from "static-path"

export const rootPath = path("/")
export const loginPath = path("/login")
export const credentialsLoginPath = path("/login/credentials")
export const detailsPath = path("/details")
export const settingsPath = path("/settings")
export const dashboardPath = path("/dashboard")
export const emailAuthPath = path("/auth/email/:email/:token/:clientAuthCode")
export const lettermemesPath = path("/lettermemes")
export const myLettermemesPath = path("/my-lettermemes")
export const myLettermemeManagePath = path("/my-lettermemes/:id")
export const myLettermemeMonetizationPath = path("/my-lettermemes/:id/monetization")
export const createLettermemePath = path("/lettermeme/new")
export const editLettermemePath = path("/lettermeme/:id/edit")
export const setupLettermemePath = path("/lettermeme/:id/setup")
export const lettermemeSourcesPath = path("/lettermeme/:id/sources")
export const lettermemeSubscribersPath = path("/lettermeme/:id/subscribers")
export const lettermemeNewsletterInputsPath = path("/lettermeme/:id/newsletter-inputs")
export const lettermemeTrackingCodePath = path("/lettermeme/:id/tracking-code")
export const lettermemeSubscribedPath = path("/:urlPath/subscribed")
export const lettermemeLatestPath = path("/:urlPath")
export const lettermemeArchivePath = path("/:urlPath/archives/:id")
export const lettermemeWeekInReviewPath = path("/:urlPath/week-in-review")
export const lettermemePath = path("/:urlPath/landing")
export const stripeOnboardingCompletePath = path("/stripe/onboarding/complete")
export const stripeOnboardingRefreshPath = path("/stripe/onboarding/refresh")
